import React, { FC} from 'react';
import { IOrder, OrderStatus } from '../../context/orders';
import OrderListItem from '../OrderListItem';
import useStyles from './styles';
import { useOrderFilterState } from '../../context/order-filter';
import OrderFilter from '../OrderFilter';

const OrderList: FC<Dictionary<IOrder>> = (ordersById) => {
  const classes = useStyles();
  const { activeOrderFilter } = useOrderFilterState();

  return (
    <OrderFilter >
      <ul className={classes.list}>
        {Object.keys(ordersById)
          .sort((a, b) => ordersById[b].timestamp - ordersById[a].timestamp)
          .filter(a => {
            return activeOrderFilter.length > 0 ? 
              !!activeOrderFilter.includes(ordersById[a].status === OrderStatus.AssignedToNextPool ? OrderStatus.Assigned : ordersById[a].status ) : a;           
          })
          .map((id) => (
            <OrderListItem key={id} {...ordersById[id]}/>

          ))}
      </ul>
    </OrderFilter>
  );
};

export default OrderList;

